package com.rainbowclubs.rainbow.presentation.common.ads

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.viewinterop.WebElementView
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLElement

private const val ClientId = "ca-pub-1219818687111267"
private const val DefaultSlotId = "3250455222"

@OptIn(ExperimentalComposeUiApi::class)
@Composable
actual fun AdBanner(modifier: Modifier) {
    val isLocalhost = window.location.hostname == "localhost" || window.location.hostname == "127.0.0.1"

    WebElementView(
        factory = {
            val root = document.createElement("div") as HTMLElement
            root.setAttribute(
                "style",
                "display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;"
            )

            if (isLocalhost) {
                // Since Google AdSense restricts serving ads to localhost/127.0.0.1 (returning a 403 Forbidden
                // or loading empty frames), we render an aesthetic placeholder to verify layout and sizing during development.
                val mockAd = document.createElement("div") as HTMLElement
                mockAd.setAttribute(
                    "style",
                    """
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        width: 320px;
                        height: 50px;
                        background: linear-gradient(135deg, #4285F4, #34A853, #FBBC05, #EA4335);
                        color: white;
                        font-family: system-ui, -apple-system, sans-serif;
                        font-size: 13px;
                        font-weight: 600;
                        border-radius: 6px;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.15);
                        text-shadow: 0 1px 2px rgba(0,0,0,0.4);
                        box-sizing: border-box;
                    """.trimIndent()
                )

                val title = document.createElement("div") as HTMLElement
                title.textContent = "Google AdSense"
                title.setAttribute("style", "font-size: 10px; opacity: 0.85; margin-bottom: 2px;")

                val label = document.createElement("div") as HTMLElement
                label.textContent = "Localhost Test Ad Banner (320x50)"

                mockAd.appendChild(title)
                mockAd.appendChild(label)
                root.appendChild(mockAd)
            } else {
                val ins = document.createElement("ins") as HTMLElement
                ins.className = "adsbygoogle"
                ins.setAttribute("style", "display:block;width:100%;height:100%;")
                ins.setAttribute("data-ad-client", ClientId)
                ins.setAttribute("data-ad-slot", DefaultSlotId)
                ins.setAttribute("data-ad-format", "auto")
                ins.setAttribute("data-full-width-responsive", "true")

                root.appendChild(ins)

                // Run on next tick to ensure the ins element is attached to the DOM before push is called
                window.setTimeout({
                    try {
                        val windowDynamic = window.asDynamic()
                        if (windowDynamic.adsbygoogle == null) {
                            windowDynamic.adsbygoogle = js("[]")
                        }
                        windowDynamic.adsbygoogle.push(js("{}"))
                    } catch (e: Throwable) {
                        console.error("Failed to load AdSense banner:", e)
                    }
                }, 50)
            }

            root
        },
        modifier = modifier
            .fillMaxWidth()
            .height(50.dp)
    )
}
